import {setAUPage, setAUService} from '@financial/common-logs'

const PAGE_AU: Record<string, string> = {
    '/myasset/card/approval': 'approval',
}

export const setMyDataAUPage = (url: string) => {
    const [pathname] = url.split('?')
    setAUService('md')
    setAUPage(PAGE_AU[pathname] || '')
}
